import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export enum CreditCardTypes {
    Unknown = 0,
    VISA = 1,
    MasterCard = 2,
    Discover = 3,
    AmericanExpress = 4,
    JCB = 5,
    EnRoute = 6,
    DinersClub = 7
}

export interface ICreditCard {
    ID: number;
    DecryptedNumber: string;
    LastFour: string;
    ExpMonth: number;
    ExpYear: number;
    StartMonth: number;
    StartYear: number;
    IsDeleted: boolean;
    CardType: CreditCardTypes;
    IsDefault: boolean;
    DateTimeLastUpdate: Date;
    CardIssueNumber: string;
    LastTransactionID: string;
    DateTimeCreated: Date;
    DateTimeLastUsed: Date;
    Status: string;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    PostalCode: string;
    Country: string;
    CreationReference: string;
    HasNotes: boolean;
    IsActive: boolean;
    Charges: number;
    Failed: number;
    IsMemberHidden: boolean;

}


export class CreditCardArray extends Array<CreditCard>  {
    public LastSort = new SortItem;

    constructor(...items: CreditCard[]) {
        super(...items);
        Object.setPrototypeOf(this, CreditCardArray.prototype);
    }

}

export class CreditCard implements ICreditCard {
    IsActive: boolean;
    ID: number;
    DecryptedNumber: string;
    LastFour: string;
    ExpMonth: number;
    ExpYear: number;
    StartMonth: number;
    StartYear: number;
    IsDeleted: boolean;
    CardType: CreditCardTypes;
    IsDefault: boolean;
    DateTimeLastUpdate: Date;
    CardIssueNumber: string;
    LastTransactionID: string;
    DateTimeCreated: Date;
    DateTimeLastUsed: Date;
    Status: string;
    FirstName: string;
    LastName: string;
    Address01: string;
    City: string;
    State: string;
    PostalCode: string;
    Country: string;
    CreationReference: string;
    HasNotes: boolean;
    Charges: number;
    Failed: number;
    IsMemberHidden: boolean;

}
